<template>
    <ModalShell title="Edit Name" subtitle="Enter the name you'd like to edit" divider-class="my-4">
        <template #icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                <path
                    d="M18.25 0.25H1.75C1.35218 0.25 0.970644 0.408035 0.68934 0.68934C0.408035 0.970644 0.25 1.35218 0.25 1.75V14.5C0.25 14.8978 0.408035 15.2794 0.68934 15.5607C0.970644 15.842 1.35218 16 1.75 16H3.25V17.5C3.25 17.6989 3.32902 17.8897 3.46967 18.0303C3.61032 18.171 3.80109 18.25 4 18.25C4.19891 18.25 4.38968 18.171 4.53033 18.0303C4.67098 17.8897 4.75 17.6989 4.75 17.5V16H15.25V17.5C15.25 17.6989 15.329 17.8897 15.4697 18.0303C15.6103 18.171 15.8011 18.25 16 18.25C16.1989 18.25 16.3897 18.171 16.5303 18.0303C16.671 17.8897 16.75 17.6989 16.75 17.5V16H18.25C18.6478 16 19.0294 15.842 19.3107 15.5607C19.592 15.2794 19.75 14.8978 19.75 14.5V1.75C19.75 1.35218 19.592 0.970644 19.3107 0.68934C19.0294 0.408035 18.6478 0.25 18.25 0.25ZM18.25 14.5H1.75V1.75H18.25V7.75H16.6863C16.4982 6.63745 15.899 5.63615 15.0075 4.94452C14.116 4.25289 12.9972 3.9214 11.8729 4.01576C10.7485 4.11012 9.70059 4.62343 8.93683 5.45397C8.17307 6.28451 7.74919 7.37167 7.74919 8.5C7.74919 9.62833 8.17307 10.7155 8.93683 11.546C9.70059 12.3766 10.7485 12.8899 11.8729 12.9842C12.9972 13.0786 14.116 12.7471 15.0075 12.0555C15.899 11.3639 16.4982 10.3625 16.6863 9.25H18.25V14.5ZM13.5475 7.75C13.3824 7.46404 13.1276 7.24054 12.8225 7.11418C12.5174 6.98782 12.1792 6.96565 11.8602 7.05111C11.5413 7.13657 11.2594 7.32489 11.0584 7.58686C10.8574 7.84882 10.7485 8.1698 10.7485 8.5C10.7485 8.8302 10.8574 9.15118 11.0584 9.41314C11.2594 9.67511 11.5413 9.86343 11.8602 9.94889C12.1792 10.0344 12.5174 10.0122 12.8225 9.88582C13.1276 9.75946 13.3824 9.53596 13.5475 9.25H15.1562C14.9737 9.95699 14.5396 10.5731 13.9352 10.983C13.3309 11.3928 12.5979 11.5681 11.8735 11.4761C11.1491 11.3841 10.4832 11.0311 10.0005 10.4832C9.51782 9.93529 9.25151 9.23018 9.25151 8.5C9.25151 7.76982 9.51782 7.0647 10.0005 6.51683C10.4832 5.96895 11.1491 5.61592 11.8735 5.52391C12.5979 5.43191 13.3309 5.60724 13.9352 6.01705C14.5396 6.42686 14.9737 7.04301 15.1562 7.75H13.5475Z"
                    fill="#181D27"
                />
            </svg>
        </template>
        <div class="name-details">
            <div class="name-div">
                <span>First Name</span>
                <prime-input-text v-model="firstName" class="w-full" type="text" placeholder="" @keydown.enter="onEnter" @keydown="letterOnlyInputHandler" />
            </div>

            <div class="name-div">
                <span>Middle Name</span>
                <prime-input-text v-model="middleName" class="w-full" type="text" placeholder="" @keydown.enter="onEnter" @keydown="letterOnlyInputHandler" />
            </div>

            <div class="name-div">
                <span>Last Name</span>
                <prime-input-text v-model="lastName" class="w-full" type="text" placeholder="" @keydown.enter="onEnter" @keydown="letterOnlyInputHandler" />
            </div>
        </div>
        <div
            v-if="nameAlreadyExists && showValidation"
            class="validation-message"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
            >
                <path
                    d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM9.375 6.25C9.375 6.08424 9.44085 5.92527 9.55806 5.80806C9.67527 5.69085 9.83424 5.625 10 5.625C10.1658 5.625 10.3247 5.69085 10.4419 5.80806C10.5592 5.92527 10.625 6.08424 10.625 6.25V10.625C10.625 10.7908 10.5592 10.9497 10.4419 11.0669C10.3247 11.1842 10.1658 11.25 10 11.25C9.83424 11.25 9.67527 11.1842 9.55806 11.0669C9.44085 10.9497 9.375 10.7908 9.375 10.625V6.25ZM10 14.375C9.81458 14.375 9.63333 14.32 9.47916 14.217C9.32499 14.114 9.20482 13.9676 9.13387 13.7963C9.06291 13.625 9.04434 13.4365 9.08052 13.2546C9.11669 13.0727 9.20598 12.9057 9.33709 12.7746C9.4682 12.6435 9.63525 12.5542 9.81711 12.518C9.99896 12.4818 10.1875 12.5004 10.3588 12.5714C10.5301 12.6423 10.6765 12.7625 10.7795 12.9167C10.8825 13.0708 10.9375 13.2521 10.9375 13.4375C10.9375 13.6861 10.8387 13.9246 10.6629 14.1004C10.4871 14.2762 10.2486 14.375 10 14.375Z"
                    fill="#D92D20"
                />
            </svg>
            <span> Name already exists </span>
        </div>
        <template #footer>
            <prime-button @click="closeDialog" class="p-btn-root_secondary" label="Cancel" />

            <prime-button
                label="Save Changes"
                variant="primary"
                :disabled="firstName === '' || lastName === '' || nameAlreadyExists"
                @click="saveName"
                :loading="isSavingName"
            />
        </template>
    </ModalShell>
</template>
<script setup lang="ts">
import ModalShell from '~/components/modals/shared/ModalShell.vue';

const personStore = usePersonStore();
const { letterOnlyInputHandler } = useUtils();
const modalData = inject('modalData') as any | undefined;

const firstName = ref(personStore.person?.first_name);
const middleName = ref(personStore.person?.middle_name);
const lastName = ref(personStore.person?.last_name);
const showValidation = ref(true);

const dialogRef = inject('dialogRef') as any;

const closeDialog = () => {
    dialogRef.value.close();
};

// Computed property to check if the name already exists among AKAs
const nameAlreadyExists = computed(() => {
    const norm = (s: any) => (s || '').toString().trim().toLowerCase();
    const trimmedFirstName = norm(firstName.value);
    const trimmedMiddleName = norm(middleName.value);
    const trimmedLastName = norm(lastName.value);

    // Return false if required fields are empty
    if (!trimmedFirstName || !trimmedLastName) {
        return false;
    }

    const person = personStore.person;
    if (!person) return false;

    // Check against existing AKAs
    const akas = person.akas || [];

    return akas.some((aka: any) => {
        const akaFirstName = norm(aka.first_name);
        const akaMiddleName = norm(aka.middle_name);
        const akaLastName = norm(aka.last_name);

        // First and last must match
        if (trimmedFirstName !== akaFirstName || trimmedLastName !== akaLastName) {
            return false;
        }

        // If both have middle names, require them to match. If either side is missing middle name, consider it a match
        if (trimmedMiddleName && akaMiddleName) {
            return trimmedMiddleName === akaMiddleName;
        }

        return true;
    });
});


const isSavingName = ref(false);

//save name
async function saveName() {
    isSavingName.value = true;
    showValidation.value = false; 
    await personStore.updatePerson({
        first_name: firstName.value,
        middle_name: middleName.value || ' ',
        last_name: lastName.value,
    });
    isSavingName.value = false;
    showValidation.value = true; 
    closeDialog();
}

const onEnter = (e: KeyboardEvent) => {
    if (firstName.value !== '' && lastName.value !== '' && !isSavingName.value) {
        saveName();
    }
};

// Parse and prefill name fields when modal opens
const parseAndPrefillName = (fullName: string) => {
    if (!fullName) return;
    
    const nameParts = fullName.trim().split(/\s+/).filter(part => part.length > 0);
    
    if (nameParts.length === 1) {
        firstName.value = nameParts[0];
    } else if (nameParts.length === 2) {
        firstName.value = nameParts[0];
        lastName.value = nameParts[1];
    } else if (nameParts.length === 3) {
        firstName.value = nameParts[0];
        middleName.value = nameParts[1];
        lastName.value = nameParts[2];
    } else if (nameParts.length > 3) {
        firstName.value = nameParts[0];
        middleName.value = nameParts[1];
        lastName.value = nameParts.slice(2).join(' ');
    }
};

// Watch for modal data changes and prefill
// Watch modalData.fullName if modalData is provided. Be defensive in case modalData isn't injected.
if (modalData) {
    watch(() => modalData.value?.fullName, (fullName) => {
        if (fullName) {
            parseAndPrefillName(fullName);
        }
        showValidation.value = true; // Reset validation when modal opens
    }, { immediate: true });
}
</script>
<style lang="scss" scoped>
.footer-actions {
    .p-btn-root_primary {
        @apply sm:px-3 px-2 py-2;
    }
}
.name-details {
    @apply flex sm:flex-row flex-col items-start gap-2.5 self-stretch;
}
.name-div {
    @apply flex flex-col items-start gap-2.5 self-stretch;

    span {
        @apply font-inter text-zinc-500 text-sm font-medium leading-5;
    }
}
.validation-message {
    @apply flex gap-1 mt-1;

    span {
        @apply text-red-600 font-inter text-sm font-normal leading-5;
    }
}
</style>
